import {
  QR_SCANNER_LIMITS,
  hasSupportedQrImageHeader,
  httpUrlFromQrValue,
  qrScanDimensions,
  validateQrImageFile
} from "./qr-code-scanner-core.js";

export const BARCODE_SCANNER_LIMITS = QR_SCANNER_LIMITS;
export const hasSupportedBarcodeImageHeader = hasSupportedQrImageHeader;
export const barcodeScanDimensions = qrScanDimensions;
export const httpUrlFromBarcodeValue = httpUrlFromQrValue;

export function validateBarcodeImageFile(file, headerBytes) {
  validateQrImageFile(file, headerBytes);
}

export function barcodeFormatLabel(format) {
  const labels = {
    AZTEC: "Aztec",
    CODABAR: "Codabar",
    CODE_39: "Code 39",
    CODE_93: "Code 93",
    CODE_128: "Code 128",
    DATA_MATRIX: "Data Matrix",
    EAN_8: "EAN-8",
    EAN_13: "EAN-13",
    ITF: "ITF",
    PDF_417: "PDF417",
    QR_CODE: "QR code",
    RSS_14: "RSS-14",
    RSS_EXPANDED: "RSS Expanded",
    UPC_A: "UPC-A",
    UPC_E: "UPC-E",
    UPC_EAN_EXTENSION: "UPC/EAN extension"
  };
  return labels[format] || String(format || "Barcode").replaceAll("_", " ");
}

export function decodedBarcodeSummary(value, format) {
  const url = httpUrlFromBarcodeValue(value);
  return { kind: barcodeFormatLabel(format), url };
}
